import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { Checkbox } from 'scy/Input';
import { AccentBody, Body, SecondarySmallAlt, AccentH5 } from 'scy/text';
import {
  accent,
  fontSizeXS,
  secondary,
  serif,
  sansSerifLight
} from 'scy/text/styles.mod.scss';
import { TextButton } from 'scy/buttons';
import { textOverflow } from 'scy/utils.mod.scss';
import { flex } from 'scy/flex.mod.scss';
import Icon from './Icon';
import margin from 'scy/margin.mod.scss';
import { checkbox, checkboxLabel } from '../styles.mod.scss';
import {
  summaryContainer,
  summaryGiftRecipient,
  summaryGiftRecipientWithNote
} from './styles.mod.scss';

function displayAddress({ address, unit, zip }) {
  return [address, unit, zip].filter(str => !_.isEmpty(str)).join(', ');
}

export default function Summary({
  isGift,
  toggleGift,
  giftRecipient,
  giftNote,
  addDeliveryNotes,
  address = {}
}) {
  return (
    <>
      <Icon />

      <div className={summaryContainer}>
        {isGift ? (
          <>
            <GiftSummary giftRecipient={giftRecipient} giftNote={giftNote} />
            <AccentBody className={textOverflow}>
              {displayAddress(address)}
            </AccentBody>
          </>
        ) : (
          <AccentH5 uppercase tag="div" className={textOverflow}>
            {displayAddress(address)}
          </AccentH5>
        )}

        {!address.shipping && (
          <DeliveryNotes
            notes={address.notes}
            addDeliveryNotes={addDeliveryNotes}
          />
        )}

        <div>
          <SecondarySmallAlt
            tag="label"
            htmlFor="isGift"
            className={checkboxLabel}
          >
            <Checkbox
              id="isGift"
              name="isGift"
              className={`${checkbox} ${margin.right_xxs}`}
              checked={isGift}
              onChange={toggleGift}
            />
            Send as a gift?
          </SecondarySmallAlt>
        </div>
      </div>
    </>
  );
}

function GiftSummary({ giftRecipient, giftNote }) {
  return (
    <Body className={summaryGiftRecipient}>
      <div
        className={classnames(textOverflow, {
          [summaryGiftRecipientWithNote]: !!giftNote
        })}
      >
        {giftRecipient}
      </div>

      {giftNote && (
        <>
          <span className={`${margin.right_xxs} ${margin.left_xxs}`}>-</span>
          <div className={`${secondary} ${serif} ${flex} ${textOverflow}`}>
            “<span className={textOverflow}>{giftNote}</span>”
          </div>
        </>
      )}
    </Body>
  );
}

function DeliveryNotes({ notes, addDeliveryNotes }) {
  return notes ? (
    <div className={`${flex} ${secondary} ${fontSizeXS}`}>
      “<div className={textOverflow}>{notes}</div>”
    </div>
  ) : (
    <div className={`${accent} ${fontSizeXS} ${sansSerifLight}`}>
      <TextButton onClick={addDeliveryNotes}>Add Delivery Notes</TextButton>
    </div>
  );
}
